'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdEventSeat = function MdEventSeat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 21.6h-16.8v-13.2c0-1.8 1.6-3.4 3.4-3.4h10c1.8 0 3.4 1.6 3.4 3.4v13.2z m-25-5h5v5h-5v-5z m28.2 0h5v5h-5v-5z m-25 18.4v-10h26.8v10h-5v-5h-16.8v5h-5z' })
        )
    );
};

exports.default = MdEventSeat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/event-seat.js
// module id = 3035
// module chunks = 0